// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import map from 'lodash/map'; // External Components

import Slider from 'react-slick';
import '../carousel.less'; // The Slider needs divs to inject style props into.
// This fn wraps given react components in divs.

var wrappedSlides = function wrappedSlides(slides) {
  return map(slides, function (slide, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: "carousel-slide-".concat(index)
    }, slide);
  });
};

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '20',
    centerMode: true,
    arrows: false
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('three-tiles__carousel', className)
  }, /*#__PURE__*/React.createElement(Slider, sliderSettings, wrappedSlides(children)));
};

Carousel.displayName = 'Carousel';
Carousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  className: PropTypes.string
};
Carousel.defaultProps = {
  children: [],
  className: ''
};
export default Carousel;